var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 2.64974C13.5179 0.814118 10.9165 -0.244462 8.0561 0.0483365C3.92313 0.465012 0.522155 3.82094 0.0604336 7.95391C-0.558949 13.4157 3.66411 18.0217 8.9908 18.0217C12.5832 18.0217 15.6689 15.9158 17.1103 12.8864C17.4707 12.1319 16.9302 11.2648 16.0968 11.2648C15.6801 11.2648 15.286 11.49 15.1058 11.8616C13.8332 14.5982 10.7814 16.3325 7.44798 15.5892C4.94792 15.0374 2.93212 12.9991 2.40283 10.499C1.45686 6.12954 4.779 2.25559 8.9908 2.25559C10.8602 2.25559 12.5269 3.03263 13.7432 4.26014L12.0427 5.96062C11.3332 6.6701 11.8287 7.88634 12.831 7.88634H16.8738C17.4932 7.88634 18 7.37957 18 6.76019V2.71731C18 1.71504 16.7838 1.20827 16.0743 1.91774L15.3535 2.64974Z",
    fill: "#45464E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resendIcon.152b8e0bfdab0ccb0873f9fdde398903.svg";
export { ForwardRef as ReactComponent };